import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import swal from 'sweetalert2';
import * as ProAct from '../../Actions/ProActions';
import { supprimerGestionnaire, obtenirProprietaire } from '../../App_Code/API';
import { mapStateToPropsWrapper, verificationProps } from '../CaptureErreurs';
import Card from '../Card';
import Adresse from '../Adresse';
import Contact from '../Contact';

function Revoquer(Gestionnaire, actions, history) {
    swal({
        title: 'Confirmation',
        text: 'Êtes-vous sûr(e) de vouloir supprimer la gestion par le gestionnaire ?',
        type: 'warning',
        showCancelButton: true,
        focusCancel: true,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Valider',
        cancelButtonText: 'Annuler',
    }).then((result) => {
        if (result.value) {
            supprimerGestionnaire(Gestionnaire).then((ok) => {
                if (ok) {
                    swal('Succès', 'La demande de la suppression du gestionnaire a été envoyée au syndic.', 'success');
                    obtenirProprietaire().then((pro) => {
                        actions.proAjout(pro);
                    });
                    history.push('/MesInformations');
                } else {
                    swal(
                        'Erreur',
                        'Une erreur est survenue lors de la demande de suppression du gestionnaire au syndic.',
                        'error',
                    );
                }
            });
        }
    });
}

const AfficherGestionnaire = ({
    titre, Gestionnaire, actions, history,
}) => (
    <Card Titre={titre} SousTitre={`${Gestionnaire.Civilite} ${Gestionnaire.Nom}`}>
        <div className="card-text mb-1">
            <Adresse {...Gestionnaire.Adresse} />
            {Gestionnaire.LsContacts.map((contact, i) => <Contact key={i} {...contact} />)}
        </div>
        <Link to="/MesInformations/Gestionnaire" className="btn btn-outline-orange mt-2">
            Demander une modification
        </Link>
        <button onClick={() => Revoquer(Gestionnaire, actions, history)} className="btn btn-outline-danger ml-3 mt-2">
            Demander la suppression
        </button>
    </Card>
);

const PasDeGestionnaire = ({ titre }) => (
    <Card Titre={titre}>
        <p className="card-text">
            <i>Vous n&apos;avez pas de gestionnaire.</i>
        </p>
        <Link to="/MesInformations/Gestionnaire" className="btn btn-outline-primary">
            Demander l&apos;ajout d&apos;un gestionnaire
        </Link>
    </Card>
);

const CardGestionnaire = ({ Gestionnaire, actions, history }) =>
    (Gestionnaire ? (
        <AfficherGestionnaire
            titre={CardGestionnaire.titleName}
            Gestionnaire={Gestionnaire}
            actions={actions}
            history={history}
        />
    ) : (
        <PasDeGestionnaire titre={CardGestionnaire.titleName} />
    ));
CardGestionnaire.displayName = 'CardGestionnaire';
CardGestionnaire.titleName = 'Mon gestionnaire';
CardGestionnaire.requiredProps = [
    // 'Gestionnaire', // Informations sur le gestionnaire
];

function mapStateToProps({
    ProStore: {
        Pro: { Gestionnaire },
    },
}) {
    return { Gestionnaire };
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(ProAct, dispatch) };
}

export default withRouter(connect(mapStateToPropsWrapper(mapStateToProps), mapDispatchToProps)(verificationProps(CardGestionnaire)));



// WEBPACK FOOTER //
// ./src/components/MesInfos/CardGestionnaire.js